export default "__VITE_ASSET__BPnvLB2r__"